<template>
    <section class="transaction-box" v-loading="isLoading">
        <title-date-component :titleOption="titleOption" :initDateRange="initDateRange" @changeDate="changeDate"></title-date-component>
        <section class="data-box">
            <line-tips-component style="margin-top:45px;" :lineTipsInfo="lineTipsInfo"></line-tips-component>
            <section class="funnel">
                <section><span>浏览</span></section>
                <section><span>下单</span></section>
                <section><span>支付</span></section>
            </section>
            <section class="data">
                <section>
                    <span title="浏览次数"><i>浏览量</i>{{ resultData.intentionPV | dataformat }}</span>
                    <span title="浏览用户数量"><i>访客数</i>{{ resultData.intentionUV | dataformat }}</span>
                </section>
                <section>
                    <span title="所售商品有下单行为的用户数量"><i>下单用户数</i>{{ resultData.orderUserNum | dataformat }}</span>
                    <span title="所售商品产生的订单数量"><i>订单量</i>{{ resultData.orderNum | dataformat }}</span>
                </section>
                <section>
                    <span title="产生的支付行为的用户数量"><i>支付用户数</i>{{ resultData.payUserNum | dataformat }}</span>
                    <span title="产生的支付订单数量"><i>支付订单量</i>{{ resultData.payOrderNum | dataformat }}</span>
                    <span title="销售额/支付用户数"><i>客单价</i>{{ resultData.customerPrice }}</span>
                </section>
            </section>
        </section>
    </section>
</template>

<style lang="scss" scoped="scoped">
.transaction-box {
    background-color: #FFF;
    border-radius: 3px;
    height: 360px;
    overflow: hidden;
    margin-top: 60px;
    width: 98%;
    margin-left: 1%;
    .title-date {
        margin-top: 10px;
        padding: 0 20px;
    }
    .data-box {
        width: 100%;
        height: 255px;
        padding-left: 40px;
        margin-top: 25px;
        overflow: hidden;
        .funnel {
            width: 258px;
            height: 100%;
            float: left;
            position: relative;
            left: -90px;
            z-index: 1;
            margin-left: 20px;
            section {
                position: relative;
                display: flex;
                justify-content: center;
                span {
                    position: absolute;
                    top: -50px;
                    color: #FFF;
                }
                &:nth-child(1) {
                    width: 100%;
                    border-top: 85px solid #64C8FD;
                    border-left: 35px solid #FFF;
                    border-bottom: 0;
                    border-right: 35px solid transparent;
                }
                &:nth-child(2) {
                    width: 188px;
                    border-top: 85px solid #4AB9FC;
                    border-left: 35px solid transparent;
                    border-bottom: 0;
                    border-right: 35px solid transparent;
                    margin-left: 35px;
                }
                &:nth-child(3) {
                    width: 118px;
                    border-top: 85px solid #29A3FC;
                    border-left: 35px solid #FFF;
                    border-bottom: 0;
                    border-right: 35px solid transparent;
                    margin-left: 70px;
                }
            }
        }
        .data {
            height: 100%;
            float: left;
            width: 52%;
            position: relative;
            left: -60px;
            overflow: hidden;
            > section {
                height: 85px;
                &:nth-child(1) {
                    background-color: #F7F9FA;
                }
                &:nth-child(3) {
                    background-color: #F7F9FA;
                }
                > span {
                    display: inline-block;
                    height: 100%;
                    width: 32%;
                    line-height: 85px;
                    font-size: 22px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    > i {
                        font-size: 14px;
                        font-style: normal;
                        width: 82px;
                        text-align: right;
                        display: inline-block;
                        margin-right: 15px;
                        color: #142C3D;
                        vertical-align: top;
                    }
                }
            }
        }
    }
}
</style>

<script>
    import TitleDateComponent from '../../../../components/title-date/TitleDate.vue'
    import LineTipsComponent from '../../../../operateData/components/line-tips/LineTips.vue'
    import menpiaoDataPlatform from 'api/menpiaoDataPlatform'
    import dataformat from '../../../../filters/data-format'
    import MomentFormat from '../../../../filters/moment-format'

    export default {
        components: {
            LineTipsComponent,
            TitleDateComponent
        },
        filters: {
            dataformat
        },
        data () {
            return {
                titleOption: {
                    title: '交易分析',
                    dateRangeSelect: true,
                    dateMaxRangeLength: 60
                },
                date: {
                    startDate: MomentFormat.getSevenDate(),
                    endDate: MomentFormat.getYestoday()
                },
                initDateRange: MomentFormat.getSevenDate() + ' ~ ' + MomentFormat.getYestoday(),
                resultData: this.resultDataSum,
                isLoading: false
            }
        },
        props: ['resultDataSum', 'salePlatform'],
        computed: {
            // 访购率指标
            lineTipsInfo () {
                return {
                    name: '访购率',
                    value: this.resultData.visitPurchaseRate,
                    unit: '%',
                    compare: this.resultData.visitPurchaseRatePercent,
                    title: '访购率'
                }
            }
        },
        watch: {
            salePlatform: {
                handler: function () {
                    this.getData();
                },
                deep: true
            },

            resultDataSum: {
                handler: function () {
                    this.resultData = this.resultDataSum;
                },
                deep: true
            }
        },
        methods: {
            getData () {
                this.isLoading = true;
                menpiaoDataPlatform.getIndexData(this.salePlatform, this.date.startDate, this.date.endDate, false)
                    .then((res) => {
                        console.log(res);
                        if (res.status === 0) {
                            this.resultData = res.data.sum === null ? {} : res.data.sum;
                        } else {
                            this.$notify.error({
                                title: '错误',
                                message: res.message || '请求失败'
                            })
                        }
                        this.isLoading = false;
                    })
                    .catch((err) => {
                        console.log(err);
                        this.isLoading = false;
                    })
            },

            // 切换日期
            changeDate (params) {
                this.date.startDate = params.dateRange.startDate;
                this.date.endDate = params.dateRange.endDate;
                this.getData();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Transaction.vue?d77a48be